import { render, staticRenderFns } from "./xLayout.vue?vue&type=template&id=1380f1d6&"
import script from "./xLayout.vue?vue&type=script&lang=js&"
export * from "./xLayout.vue?vue&type=script&lang=js&"
import style0 from "./xLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports